import React from 'react'

const ImcedTramites = () => {
  return (
    <div>ImcedTramites</div>
  )
}

export default ImcedTramites